// BASE SELECTORS

import {
  APPOINTMENTS,
  BACKENDNOTIFICATIONS,
  FIMLAB,
  GLOBALNOTIFICATIONS,
  HPA,
  LINKKIPALVELU,
  QUESTIONNAIRES,
  SERVICES,
  TIMELINE,
  USER,
} from './reducer';

export const timelineSelector = (state) => state[TIMELINE];
export const fimlabSelector = (state) => state[FIMLAB];
export const notificationSelector = (state) => state[BACKENDNOTIFICATIONS];
export const globalNotificationSelector = (state) => state[GLOBALNOTIFICATIONS];
export const appointmentSelector = (state) => state[APPOINTMENTS].appointments;
export const appointmentReservationSelector = (state) =>
  state[APPOINTMENTS].reservation;
export const queueAppointmentsSelector = (state) =>
  state[APPOINTMENTS].queueAppointments;
export const questionnaireSelector = (state) => state[QUESTIONNAIRES];
export const hpaSelector = (state) => state[HPA];
export const serviceSelector = (state) => state[SERVICES];
export const gtiSelector = (state) => state[SERVICES].gti;
export const userSelector = (state) => state[USER];
export const linkkipalveluSelector = (state) => state[LINKKIPALVELU];
